/* [BD] Studies slider — bd-studies-slider.liquid */
;(function () {
  function initBdStudiesSlider(root) {
    if (!root) return;

    var track = root.querySelector('.bd-studies-slider__track');
    var slides = root.querySelectorAll('.bd-studies-slider__slide');
    var dots = root.querySelectorAll('[data-bd-studies-slide-target]');

    if (!track || !slides.length || !dots.length) return;

    var currentIndex = 0;

    function goTo(id) {
      var targetIndex = Array.prototype.findIndex.call(slides, function (slide) {
        return slide.getAttribute('data-bd-studies-slide') === id;
      });
      if (targetIndex < 0) return;

      currentIndex = targetIndex;
      var offset = -targetIndex * 100;
      track.style.transform = 'translateX(' + offset + '%)';

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === targetIndex);
      });

      dots.forEach(function (dot) {
        var active = dot.getAttribute('data-bd-studies-slide-target') === id;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var id = dot.getAttribute('data-bd-studies-slide-target');
        goTo(id);
      });
    });

    var viewport = root.querySelector('.bd-studies-slider__viewport');
    if (viewport && 'addEventListener' in viewport) {
      viewport.addEventListener(
        'wheel',
        function (event) {
          var deltaX = event.deltaX || 0;
          var deltaY = event.deltaY || 0;

          if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

          event.preventDefault();

          var nextIndex = currentIndex + (deltaX > 0 ? 1 : -1);
          nextIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
          if (nextIndex === currentIndex) return;

          var nextSlide = slides[nextIndex];
          var id = nextSlide && nextSlide.getAttribute('data-bd-studies-slide');
          if (id) {
            goTo(id);
          }
        },
        { passive: false }
      );
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
            }
          });
        },
        { root: root.querySelector('.bd-studies-slider__viewport') || null, threshold: 0.4 }
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    } else {
      slides.forEach(function (slide) {
        slide.classList.add('is-inview');
      });
    }
  }

  function boot(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-bd-studies-slider]').forEach(initBdStudiesSlider);
    if (root.matches && root.matches('[data-bd-studies-slider]')) {
      initBdStudiesSlider(root);
    }
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionStudiesSliderDesignMode) {
    window.__bdSectionStudiesSliderDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
